import { FEATURES } from 'config';
import pairedMap from 'helpers/fp/pairedMap';
import { configureFeaturesToggle } from 'modules/redux-features';
import * as checkers from './checkers';

const extendedFeatures = pairedMap(
  ([featureName, checkers]) => [
    featureName,
    { or: { ...checkers, hasCookie: true } },
  ],
  FEATURES,
);

const featuresToggle = configureFeaturesToggle(extendedFeatures, checkers);

export const features = featuresToggle();

export const isExclusiveFeature = features.isExclusive;
export const isCommercialCarsFilterFeature = features.isCommercialCarsFilter;
export const isFinanceCalculatorFeature = features.isFinanceCalculator;
export const isFinanceWidgetFeature = features.isFinanceWidget;
export const isEmailSubscriptionWidgetFeature =
  features.isEmailSubscriptionWidget;
export const isSecondaryPromoBannerFeature = features.isSecondaryPromoBanner;
export const isSellWidgetFeature = features.isSellWidget;
export const isMonthlyPriceAvailableFeature = features.isMonthlyPriceAvailable;
export const isEmissionStickerFeature = features.isEmissionSticker;
export const thankYouPhoneFeature = features.thankYouPhone;
export const phonePreferenceFeature = features.phonePreference;
export const updateEmailThankYouFeature = features.updateEmailThankYou;
export const { showPhoneFieldInLastStep } = features;
